export default [
    {
        name: "module-1"
    }
]